import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-down-right', 'ArrowDownRight', [["path",{"d":"m6.5 6.5 11 11m0 0h-9m9 0v-9","key":"svg-0"}]]);